export const environment = {
  production: true,
  apiKey: '271f5ee338641272122ca858b5627325',
};
